import { Button } from "@/components/ui/button";
import { ArrowRight, Shield } from "lucide-react";
import cyberFox from "@/assets/cyber-fox-new.png";
const Hero = () => {
  return <section className="relative min-h-screen flex items-center pt-20 sm:pt-16 md:pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <picture>
          <source srcSet="/hero-cyber-optimized.webp" type="image/webp" />
          <img src="/hero-cyber.jpg" alt="Professional cyber security team protecting UK businesses from cyber threats" className="w-full h-full object-cover" width="1920" height="1080" fetchPriority="high" />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/95 to-primary/80" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 md:gap-8 lg:gap-12">
          <div className="max-w-3xl flex-1 md:max-w-2xl lg:max-w-3xl">
          <div className="flex items-center gap-2 mb-4 sm:mb-6">
            <Shield className="text-accent w-8 h-8" />
            <span className="text-accent font-semibold text-sm uppercase tracking-wider">
              Award-Winning Cyber Security | 24/7 Emergency Response
            </span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 text-balance tracking-normal">Expert Cyber Security Services for UK Business</h1>
          
          <p className="text-lg sm:text-xl text-white/90 mb-8 text-balance max-w-2xl md:max-w-xl lg:max-w-2xl">
            Strategic cyber security leadership for growing UK businesses. 
            Protect your organisation with experienced fractional CISO support across the United Kingdom.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href="/resources">
              <Button size="lg" className="bg-accent hover:bg-accent/90 text-white text-lg h-12 md:h-13 lg:h-14 px-6 sm:px-8 w-full">
                Get Free Security Checklist
              </Button>
            </a>
            <a href="/assessment">
              <Button size="lg" variant="secondary" className="text-lg h-12 md:h-13 lg:h-14 px-6 sm:px-8 w-full">
                Take 2-Minute Security Assessment
              </Button>
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 border-t border-white/20">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-5 md:gap-6 text-white">
              <div>
                <div className="text-3xl font-bold text-accent">25+</div>
                <div className="text-sm text-white/80">Years Experience</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent">50+</div>
                <div className="text-sm text-white/80">UK Businesses</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent">98%</div>
                <div className="text-sm text-white/80">Pass Rate</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-accent">24/7</div>
                <div className="text-sm text-white/80">Emergency Response</div>
              </div>
            </div>
          </div>
          </div>
        
        {/* Fox Illustration */}
        <div className="hidden lg:flex flex-shrink-0 items-center justify-center animate-fade-in">
          <img src={cyberFox} alt="4FOX Security friendly cyber security expert mascot illustration" className="w-96 h-auto drop-shadow-2xl" fetchPriority="high" width="384" height="384" />
        </div>
        </div>
      </div>
    </section>;
};
export default Hero;